"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ECorporationFormeJuridique_1 = require("../../enums/CorporationSheet/ECorporationFormeJuridique");
const EQualiteRepresentant_1 = require("../../enums/CorporationSheet/EQualiteRepresentant");
const ERegimeFiscal_1 = require("../../enums/CorporationSheet/ERegimeFiscal");
const EResidenceFiscale_1 = require("../../enums/CorporationSheet/EResidenceFiscale");
const ECorporationResourceGroups_1 = require("../../enums/CorporationSheet/Groups/ECorporationResourceGroups");
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
const AddressCreateRequestResource_1 = __importDefault(require("../Address/AddressCreateRequestResource"));
const ClientSheetUpdateBeneficiaryRequestResource_1 = __importDefault(require("../ClientSheet/ClientSheetUpdateBeneficiaryRequestResource"));
const CustomAsync_1 = __importDefault(require("../decorators/CustomAsync"));
const Di_1 = __importDefault(require("../injectables/Di"));
const Resource_1 = __importDefault(require("../Resource"));
class CorporationSheetCreateRequestResource extends Resource_1.default {
}
exports.default = CorporationSheetCreateRequestResource;
__decorate([
    (0, class_validator_1.IsString)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.raisonSociale] }),
    (0, class_validator_1.IsNotEmpty)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.raisonSociale] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CorporationSheetCreateRequestResource.prototype, "raisonSociale", void 0);
__decorate([
    (0, CustomAsync_1.default)((siret) => Di_1.default.getCorporationService().isUniqueSiret(siret), {
        message: ValidationErrors_1.EValidationError.uniqueSiret,
        groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.siret],
    }),
    (0, class_validator_1.IsNumberString)({ no_symbols: true }, { groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.siret] }),
    (0, class_validator_1.MaxLength)(14, { context: [14], groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.siret] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CorporationSheetCreateRequestResource.prototype, "siret", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ECorporationFormeJuridique_1.ECorporationFormeJuridique, { groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.formeJuridique] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CorporationSheetCreateRequestResource.prototype, "formeJuridique", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((object) => object.formeJuridique === ECorporationFormeJuridique_1.ECorporationFormeJuridique.other, {
        groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.formeJuridique],
    }),
    (0, class_validator_1.IsNotEmpty)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.formeJuridique] }),
    (0, class_validator_1.MaxLength)(60, { context: [60], groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.formeJuridique] }),
    (0, class_validator_1.IsString)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.formeJuridique] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], CorporationSheetCreateRequestResource.prototype, "formeJuridiqueAutre", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AddressCreateRequestResource_1.default),
    (0, class_validator_1.IsNotEmpty)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.siegeSocial] }),
    (0, class_validator_1.ValidateNested)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.siegeSocial] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", AddressCreateRequestResource_1.default)
], CorporationSheetCreateRequestResource.prototype, "siegeSocial", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(EResidenceFiscale_1.EResidenceFiscale, { groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.residenceFiscale] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CorporationSheetCreateRequestResource.prototype, "residenceFiscale", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((object) => object.residenceFiscale === EResidenceFiscale_1.EResidenceFiscale.horsUE, {
        groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.residenceFiscaleAutre],
    }),
    (0, class_validator_1.IsNotEmpty)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.residenceFiscaleAutre] }),
    (0, class_validator_1.MaxLength)(60, { context: [60], groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.residenceFiscaleAutre] }),
    (0, class_validator_1.IsString)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.residenceFiscaleAutre] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], CorporationSheetCreateRequestResource.prototype, "residenceFiscaleAutre", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ERegimeFiscal_1.ERegimeFiscal, { groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.regimeFiscal] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CorporationSheetCreateRequestResource.prototype, "regimeFiscal", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.assujettiIFI] }),
    (0, class_validator_1.IsBoolean)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.assujettiIFI] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], CorporationSheetCreateRequestResource.prototype, "assujettiIFI", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(EQualiteRepresentant_1.EQualiteRepresentant, { groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.qualiteRepresentantLegal] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CorporationSheetCreateRequestResource.prototype, "qualiteRepresentantLegal", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => ClientSheetUpdateBeneficiaryRequestResource_1.default),
    (0, class_validator_1.IsNotEmpty)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.representantLegal] }),
    (0, class_validator_1.ValidateNested)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.representantLegal] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", ClientSheetUpdateBeneficiaryRequestResource_1.default)
], CorporationSheetCreateRequestResource.prototype, "representantLegal", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => ClientSheetUpdateBeneficiaryRequestResource_1.default),
    (0, class_validator_1.IsNotEmpty)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.beneficiaries] }),
    (0, class_validator_1.ValidateNested)({ groups: [ECorporationResourceGroups_1.ECorporationResourceGroups.beneficiaries] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], CorporationSheetCreateRequestResource.prototype, "beneficiaries", void 0);
